/**
 * La definición ÚNICA de «línea de seguimiento» (card mFHzKeNK, decisión de fede del 25/09).
 *
 * El concepto (`BusinessUnit` en el código) se explica con la misma frase en todo el producto: el ⓘ
 * de la card de líneas, los estados vacíos, la fila del Listado v2 y el glosario del AI Booster la
 * leen de acá. Dos textos más la llevan ADENTRO, porque son claves que se renderizan por nombre
 * dinámico y no pueden componerse: `setup_helper.steps.useful_dashboard.text` y
 * `line_wizard.client.subtitle`. `__tests__/lineDefinition.test.js` recorre los dos bundles y falla
 * si alguno se aparta de la definición.
 *
 * Presupuesto y objetivo van juntos a propósito: sólo el 23% de las líneas tiene objetivo, y es lo
 * que le da criterio a la IA. Una definición que nombrara sólo el presupuesto lo escondería.
 */
export const LINE_DEFINITION_KEY = 'business_unit.definition';
export const LINE_DEFINITION_DEFAULT = 'Una línea de seguimiento junta campañas de un cliente con su '
    + 'presupuesto del mes y su objetivo. Con eso, tu tablero te avisa si algo se desvía y tu IA sabe '
    + 'si va bien.';

export const LINE_DEFINITION_TITLE_KEY = 'business_unit.definition_title';
export const LINE_DEFINITION_TITLE_DEFAULT = '¿Qué es una línea de seguimiento?';

// El link al artículo canónico del Centro de Ayuda, debajo de la definición en los estados vacíos.
export const LINE_DEFINITION_MORE_KEY = 'business_unit.definition_more';
export const LINE_DEFINITION_MORE_DEFAULT = 'Más sobre las líneas de seguimiento';

export function lineDefinition(t) {
    return t(LINE_DEFINITION_KEY, LINE_DEFINITION_DEFAULT);
}

export function lineDefinitionTitle(t) {
    return t(LINE_DEFINITION_TITLE_KEY, LINE_DEFINITION_TITLE_DEFAULT);
}

export function lineDefinitionMore(t) {
    return t(LINE_DEFINITION_MORE_KEY, LINE_DEFINITION_MORE_DEFAULT);
}
